<template>
    <div style="margin: 10px">
        <v-form>
            <v-card>
                <div class="headline dialog-header">
                    <v-toolbar color="primary" dark>
                        <v-toolbar-title style="padding-left: 10px"
                            >{{ $t(formName) }}
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-btn
                        @click="onCancel"
                        icon
                        style="
                            position: absolute;
                            right: 10px;
                            top: 10px;
                            color: #fff;
                        "
                    >
                        <v-icon>cancel</v-icon>
                    </v-btn>
                </div>
                <v-card-text>
                    <v-layout wrap>
                        <v-flex xs12 sm12 md6>
                            <div style="padding: 0px 10px">
                                <p class="font-weight-bold">
                                    Số phiếu nhập kho:
                                    {{ createItem.importNumber }}
                                </p>
                                <p class="font-weight-bold">
                                    Số thông báo:
                                    {{ importRequest != null && importRequest.requestNumber }}
                                </p>
                                <p class="font-weight-bold">
                                    Mã kho: {{ this.warehouseCode }}
                                </p>
                            </div>
                        </v-flex>
                        <v-flex xs12 sm12 md6>
                            <p class="font-weight-bold">
                                Ngày dự kiến giao hàng: {{ importRequest != null ? this.dateFormat(importRequest.dateArrived) : '' }}
                            </p>
                            <div>
                                <i-datepicker
                                    label="Ngày giao hàng"
                                    v-model="createItem.dateArrived"
                                    :minDate="minDate()"
                                />
                            </div>
                            <div>
                                <v-text-field 
                                    label="Người giao hàng"
                                    v-model="createItem.deliveryPerson" 
                                />
                            </div>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex>
                            <table class="lstTable">
                                <tr>
                                    <th width="10%">{{$t('lang.material.materialType')}}</th>
                                    <th width="15%">Tên vật tư</th>
                                    <th width="5%">Đơn vị</th>
                                    <th width="10%">Đóng gói</th>
                                    <th width="10%">Số lượng dự kiến giao</th>
                                    <th width="10%">Thực nhập</th>
                                    <th width="20%">Nhà cung cấp</th>
                                    <th width="15%">Hạn sử dụng</th>
                                </tr>
                                <template v-for="(item, index) in lstMaterial">
                                    <tr v-if="item.row === 0" :key="index">
                                        <td style="font-weight: bold">{{item.typeName}}</td>
                                        <td colspan="7">Không có vật tư</td>
                                    </tr>
                                    <tr v-else :key="index">
                                        <td :rowspan="item.row" v-if="item.row != undefined && item.row > 0" style="font-weight: bold">{{item.typeName}}</td>
                                        <td>{{ item.materialName }}</td>
                                        <td style="text-align: center">{{ item.unit }}</td>
                                        <td style="text-align: center">{{ item.pack }}</td>
                                        <td style="text-align: center">{{ item.orderQuantity | currency }}</td>
                                        <td>
                                          <c-input-number
                                                v-model="lstMaterial[index].actualImport"
                                                v-on:input="setInput"
                                                @keydown="keyProcess"
                                                :id="'input_' + index"
                                                :data-index="index"
                                                style="text-align: center"
                                            />
                                        </td>
                                        <td>
                                            <template v-for="(supplier, i) in lstSupplier">
                                                <span v-if="supplier.partnerId == item.supplyId" :key="i">
                                                    {{ supplier.partnerName }}
                                                </span>
                                            </template>
                                            <!-- <v-select
                                                :items="lstSupplier"
                                                label="Nhà cung cấp"
                                                v-model="lstMaterial[index].supplyId"
                                                item-value="partnerId"
                                                item-text="partnerName"
                                                clearable
                                            /> -->
                                        </td>
                                        <td>
                                            <i-datepicker
                                                v-model="lstMaterial[index].expiryDate"
                                                :minDate="minDate()"
                                            />
                                        </td>
                                    </tr>
                                </template>
                            </table>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn color="primary" @click="onSave" :disabled="loading">
                        {{ $t("Nhập kho") }}
                    </v-btn>
                    <v-btn color="error" @click="onCancel" :disabled="loading">
                        {{ $t("lang.common.cancel") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import IDatepicker from "../../../components/form/DatePicker";
import { message } from "../../../shared/message";
import CTextboxFloat from "@/components/form/TextboxFloat";

export default {
    name: "ImportWhCreate",
    components: {CTextboxFloat, IDatepicker },
    data: () => {
        return {
            formName: "Phiếu nhập kho",
            loading: false,
            warehouseCode: "",
            materials: [],
            lstSupplier: [],
            lstWarehouse: [],
            lstMaterialType: [],
            lstMaterial: [],
            requestOrder: null,
            importRequest: null,
            createItem: {
                // "content": "",
                "deliveryPerson": "",
                // "importDate": "",
                "importNumber": 0,
                // "importRequestId": 0,
                // "status": 0,
                "supplyId": '',
                // "totalAfterVat": 0,
                // "totalAmount": 0,
                // "userCreateId": 0,
                // "userGroupId": 0,
                // "vat": 0,
            },
        };
    },

    created() {
        // 2: thủ kho;  26: mua hàng
        const role = parseInt(this.$store.state.auth.user.role);
        if (role != 2 && role != 3) {
            this.$router.push({ path: '/importRequest' });
        }

        this.createItem.importRequestId = this.$route.params.id;
        this.createItem.userCreateId = this.$store.state.auth.user.userId
        this.createItem.userCreateName = this.$store.state.auth.user.fullName

        this.getImportRequest();
        this.getSuppliers();
        this.getNextCode();
    },

    methods: {
        //linhdx reload lai array thi moi hien thi dc c-textbox-float
        setInput(){
          this.lstMaterial = [...this.lstMaterial]
          console.log(this.lstMaterial)
        },
        onCancel() {
            this.$router.push({ path: '/importRequest/view/' + this.$route.params.id, query: this.$route.query});
        },
        onSave() {
            const lstMaterial_tmp = this.lstMaterial;

            // const totalActualImport = lstMaterial_tmp.reduce((n, {actualImport}) => n + actualImport, 0)
            // if (parseInt(totalActualImport) <= 0) {
            //     message.error("Bạn chưa nhập số lượng vật tư thực nhập");
            //     return;
            // }

            let importSuccess = 1;
            let incomplete = 0;
            let rt = true;
            let supplyId = '';
            $.each(lstMaterial_tmp, function (k, v) {
                
                if (v.actualImport === '' || v.actualImport === null) {
                    message.error("Bạn chưa nhập số lượng vật tư thực nhập");
                    // console.log(k);
                    var input_id = "input_" + k;
                    var element = document.getElementById(input_id);
                    if (typeof element != "undefined" && element != null) {
                        element.focus();
                    }
                    // console.log(v.actualImport);
                    rt =  false;
                    return
                }
                
                const totalImport = parseFloat(v.actualImport) + parseFloat(v.totalImportQuantity);
                console.log(v.buyNumberPropose, totalImport);
                if (v.buyNumberPropose != totalImport) {
                    importSuccess = 0;
                    if (v.buyNumberPropose < totalImport) {
                        incomplete = 1
                    } else if (v.buyNumberPropose > totalImport) {
                        incomplete = 2
                    }
                }

                if (k == 0) {
                    supplyId += lstMaterial_tmp[k].supplyId;
                } else {
                    supplyId += ',' + lstMaterial_tmp[k].supplyId;
                }

                lstMaterial_tmp[k].amount = v.actualImport * parseFloat(v.price);
                lstMaterial_tmp[k].quantity = v.actualImport;
                lstMaterial_tmp[k].totalImportQuantity = totalImport;
            });
            if(!rt){
              this.loading = false;
              return;
            }

            const createItem = this.createItem;
            createItem.importSuccess = importSuccess;
            createItem.incomplete = incomplete;
            createItem.supplyId = supplyId;
            createItem.requestData = JSON.stringify(lstMaterial_tmp);
            console.log(createItem);
            // return;
            this.loading = true;
            axios
                .post(process.env.VUE_APP_API_URL + "/importWh/save", createItem)
                .then(
                    (data) => {
                        // console.log(data);
                        if (data.success) {
                            message.success(this.$t("lang.common.save_success"));
                            this.$router.push({ path: '/importRequest', query: this.$route.query });
                            this.loading = false;
                        } else {
                            message.error(this.$t(data.description));
                            this.loading = false;
                        }
                    },
                    (error) => {
                        console.log(error);
                    }
                );
        },
        getImportRequest() {
            if (this.$route.params.id) {
                axios
                    .post(
                        process.env.VUE_APP_API_URL + "/importRequest/detail/" + this.$route.params.id
                    )
                    .then((data) => {
                        if (typeof data == "object") {
                            this.createItem.reqOrdId = data.reqOrdId;
                            this.createItem.warehouseId = data.warehouseId;
                            this.createItem.importRequestNumber = data.requestNumber;
                            this.importRequest = data;
                            this.getRequestOrder(data.reqOrdId);
                            this.getWarehouses(data.warehouseId);
                            const lstMaterial = JSON.parse(data.requestData);
                            // console.log(lstMaterial);
                            $.each(lstMaterial, function (k, v) {
                                lstMaterial[k].actualImport = v.orderQuantity;
                                lstMaterial[k].expiryDate = null;
                            });
                            this.lstMaterial = lstMaterial;
                        }
                    });
            }
        },
        getRequestOrder(reqOrdId) {
            if (reqOrdId) {
                axios
                    .post(
                        process.env.VUE_APP_API_URL + "/requestOrder/detail/" + reqOrdId
                    )
                    .then((data) => {
                        if (typeof data == "object") {
                            this.requestOrder = data;
                            this.createItem.areaId = data.areaId;
                            this.createItem.requestOrderNumber = data.requestNumber;

                            // this.getWarehouses(data.areaId);
                        }
                    });
            }
        },
        getSuppliers() {
            axios.post(
                    process.env.VUE_APP_API_URL + "/partner/suppliers?pageSize=-1&page=-1",
                    { status: 1 }
                )
                .then((data) => {
                    if (data.items) {
                        this.lstSupplier = data.items;
                    }
                });
        },
        getWarehouses(categoryId) {
            axios
                .post(
                    process.env.VUE_APP_API_URL + "/category/onSearchAllStatus?pageSize=-1&page=-1&categoryTypeCode=WAREHOUSE",
                    { categoryId }
                )
                .then((data) => {
                    if (data.items != undefined && data.items.length > 0) {
                        this.warehouseCode = data.items[0].categoryName;
                        this.createItem.areaId = data.items[0].parentId;
                    }
                });
        },
        getNextCode() {
            axios
                .get(
                    process.env.VUE_APP_API_URL +
                        "/autoIncrease/getNextCode?type=PNK&prefix=PNK/&numberZeroBeforeCodeNumberCode=2&suffix="
                )
                .then((data) => {
                    this.createItem.importNumber = data;
                });
        },
        keyProcess($event) {
            let index = parseInt($event.target.getAttribute("data-index"));
            let input_id = '';
            switch ($event.keyCode) {
                case 13:
                    index += 1;
                    input_id = "input_" + index;
                    var element = document.getElementById(input_id);
                    if (typeof element != "undefined" && element != null) {
                        element.focus();
                    } else {
                        $event.target.blur(); 
                    }
                    $event.preventDefault();
                    break;
                case 38:
                    // up
                    if (index > 0) {
                        index -= 1;
                        input_id = "input_" + index;
                        var element = document.getElementById(input_id);
                        if (typeof element != "undefined" && element != null) {
                            element.focus();
                        }
                    }
                    $event.preventDefault();
                    break;
                case 40:
                    //down
                    index += 1;
                    input_id = "input_" + index;
                    var element = document.getElementById(input_id);
                    if (typeof element != "undefined" && element != null) {
                        element.focus();
                    }
                    $event.preventDefault();
                    break;
            }
        },
        minDate() {
            const minDate = moment().format('YYYY-MM-DD');
            return minDate;
        },
        dateFormat(date) {
            return moment(String(date)).format('DD-MM-YYYY');
        },
    },

    destroyed() {},
};
</script>
